import { useTranslation } from "react-i18next";

//#region src/framework/utils/format-time/format-time.ts
/**
* Formats input to hh:mm AM/PM time.
* @example
* const formattedTime = formatTime('18:00:00') // returns 6:00 pm
*
* @param {string} time - Time to be converted.
* @returns {string | undefined} This function returns a formatted time string.
*/
const formatTime = (time) => {
	const { t } = useTranslation("pds");
	const [hours, minutes, _seconds] = time.split(":").map(Number);
	const timePeriod = hours >= 12 ? t("timePeriod.pm") : t("timePeriod.am");
	return `${hours % 12 || 12}:${minutes.toString().padStart(2, "0")} ${timePeriod}`;
};

//#endregion
export { formatTime };